import { useTranslation } from "react-i18next";
import { Modal } from "../ui/Modal/Modal";
import { LoadingSpinner } from "../ui/LoadingSpinner/LoadingSpinner";
import { ErrorFallback } from "../ui/ErrorFallback/ErrorFallback";
import { useProductionUnits } from "../../hooks/use-orders";
import styles from "./ProductionUnitPickerModal.module.css";

interface ProductionUnitPickerModalProps {
	orderId: string | null;
	onClose: () => void;
	onSelectSerial: (serialNo: string) => void;
}

const STATUS_LABEL_KEY: Record<string, string> = {
	done: "productionStatusDone",
	in_progress: "productionStatusInProgress",
	waiting: "productionStatusWaiting",
	paused: "productionStatusPaused",
	planned: "productionStatusPlanned",
};

export function ProductionUnitPickerModal({
	orderId,
	onClose,
	onSelectSerial,
}: ProductionUnitPickerModalProps) {
	const { t } = useTranslation();
	const query = useProductionUnits(orderId ?? "");
	const units = query.data?.lines.flatMap((l) => l.units) ?? [];

	return (
		<Modal isOpen={!!orderId} onClose={onClose} title={t("unitSerial")} maxWidth={420}>
			{query.isLoading && <LoadingSpinner />}
			{query.isError && <ErrorFallback onRetry={query.refetch} />}
			{query.data && units.length === 0 && <p className={styles.empty}>{t("noProductionData")}</p>}
			<div className={styles.list}>
				{units.map((unit) => (
					<button
						key={unit.serialNo}
						type="button"
						className={styles.unitItem}
						onClick={() => {
							onSelectSerial(unit.serialNo);
							onClose();
						}}
					>
						<span className={styles.serial}>{unit.serialNo}</span>
						<span className={[styles.statusBadge, styles[`badge_${unit.status}`]].join(" ")}>
							{t(STATUS_LABEL_KEY[unit.status] ?? unit.status)}
						</span>
					</button>
				))}
			</div>
		</Modal>
	);
}
